import type { BprojViewSnapshot } from './serialization';
import { useProjectStore } from '../store/project-store';

export function captureCurrentViewSnapshot(): BprojViewSnapshot {
  const state = useProjectStore.getState();
  return {
    activeView: state.activeView,
    timeScale: state.timeScale,
    collapsedTaskIds: state.collapsedTaskIds,
    columns: state.columns,
    showBaseline: state.showBaseline,
    showCriticalPath: state.showCriticalPath,
    scheduleMode: state.schedule.mode,
    reportPresets: state.reportPresets,
    activeReportPresetId: state.activeReportPresetId,
  };
}

export function restoreViewSnapshot(view: BprojViewSnapshot): void {
  const state = useProjectStore.getState();
  state.setActiveView(view.activeView);
  state.setTimeScale(view.timeScale);
  state.setCollapsedTaskIds(view.collapsedTaskIds);
  state.setColumns(view.columns);
  state.setShowBaseline(view.showBaseline);
  state.setShowCriticalPath(view.showCriticalPath);
  state.setScheduleMode(view.scheduleMode);
  state.restoreReportPresetState(view.reportPresets, view.activeReportPresetId);
}
